import { cn } from "@/lib/utils";

interface SectionHeaderProps {
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  align?: "left" | "center";
  className?: string;
}

export function SectionHeader({
  eyebrow,
  title,
  description,
  align = "center",
  className,
}: SectionHeaderProps) {
  return (
    <div
      className={cn(
        "max-w-3xl mb-12 md:mb-16",
        align === "center" ? "mx-auto text-center" : "text-left",
        className
      )}
    >
      {eyebrow && (
        <p className="text-sm uppercase tracking-[0.2em] text-oceanBlue font-medium mb-3">
          {eyebrow}
        </p>
      )}
      <h2 className="font-playfair text-3xl sm:text-4xl lg:text-5xl font-bold text-deepOcean leading-tight">
        {title}
      </h2>
      {description && (
        <p className="mt-4 text-textBody/70 text-base md:text-lg leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
}
